import axios from "axios";
import { getXRFHeaderValue } from "../utils/getXRFHeaderValue";

const containerItemId = "{A892924B-A99B-4346-AEBF-00997FEEFED5}";
        
class PageCategoryService {
  getOptions() {
    return {
      headers: {
        "content-type": "application/json",
        "X-RequestVerificationToken": getXRFHeaderValue(),
        "X-Requested-With": "XMLHttpRequest"
      },
      withCredentials: true
    };
  }

  getCategories() {
    const uri = `/sitecore/api/ssc/item/${containerItemId}/children?includeMetadata=false&fields=Name,Color,Pattern&sc_content=master`;
    return axios
      .get(uri, this.getOptions())
      .then(res => {
        const all = { "Name": "All", "Color": "grey", "Pattern": "" };
        const categories = res.data;
        categories.unshift(all);
        return categories;
      })
      .catch(err => {
        console.error(err);
        return [];
      });
  }


}

export default new PageCategoryService();



// WEBPACK FOOTER //
// ./src/data/PageCategoryService.prod.js